export default __webpack_public_path__ + "static/declarative-design-system-1808ee3a2adcfda0379f81cbebf3e71e.png";